// extracted by mini-css-extract-plugin
module.exports = {"fieldErrorMessage":"SelfServiceAccountActivation_fieldErrorMessage__1bDm5","captchaImage":"SelfServiceAccountActivation_captchaImage__3ygY-"};